var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.499 20.2617H5.93262V19.7051C5.93262 18.7578 6.04004 17.9912 6.25488 17.4053C6.46973 16.8096 6.78711 16.2676 7.20703 15.7793C7.63672 15.291 8.59375 14.4316 10.0781 13.2012C10.8691 12.5566 11.2646 11.9658 11.2646 11.4287C11.2646 10.8916 11.1035 10.4766 10.7812 10.1836C10.4688 9.88086 9.99023 9.72949 9.3457 9.72949C8.65234 9.72949 8.07617 9.95898 7.61719 10.418C7.16797 10.877 6.87988 11.6777 6.75293 12.8203L1.06934 12.1172C1.26465 10.0273 2.02148 8.34766 3.33984 7.07812C4.66797 5.79883 6.69922 5.15918 9.43359 5.15918C11.5625 5.15918 13.2812 5.60352 14.5898 6.49219C16.3672 7.69336 17.2559 9.29492 17.2559 11.2969C17.2559 12.127 17.0264 12.9277 16.5674 13.6992C16.1084 14.4707 15.1709 15.4131 13.7549 16.5264C12.7686 17.3076 12.1436 17.9375 11.8799 18.416C11.626 18.8848 11.499 19.5 11.499 20.2617ZM5.74219 21.7412H11.7041V27H5.74219V21.7412Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.3ef2b4867f932d12a42a1f6a91aefe74.svg";
export { ForwardRef as ReactComponent };